import { computed, defineComponent, ref } from '@vue/composition-api';
import { ClusteredMap } from '@/components/Map';
import { MapDataType } from '@/components/Map/types';
export default defineComponent({
    components: { ClusteredMap },
    props: {
        offerId: {
            type: String,
            required: true,
        },
        objectCategories: {
            type: Object,
            default: () => ({
                offer: [],
                reservation: [],
                contract: [],
            }),
        },
        activeMarkerId: {
            type: String,
            default: null,
        },
    },
    setup(props, ctx) {
        const mapRefreshKey = ref(0);
        const dataSets = computed(() => {
            return [
                {
                    name: 'offer-objects',
                    url: 'objects-map',
                    query: {
                        offerId: props.offerId,
                    },
                    type: MapDataType.OBJECT,
                    fetchAll: true,
                    labelAccessor: ['internalNumber'],
                    labelFormatter: (label) => `#${label}`,
                    categorizeObjects: true,
                    objectCategories: props.objectCategories,
                },
                {
                    name: 'places',
                    url: 'places',
                    query: {
                        isPositionDefined: true,
                        offerId: props.offerId,
                    },
                    type: MapDataType.PLACE,
                    fetchAll: true,
                    labelAccessor: ['number'],
                    labelFormatter: (label) => `#${label}`,
                },
                {
                    name: 'hardcoded-objects',
                    url: 'objects-map',
                    query: {
                        isHardcoded: true,
                    },
                    type: MapDataType.OBJECT,
                    fetchAll: true,
                    labelAccessor: ['internalNumber'],
                    labelFormatter: (label) => `#${label}`,
                    excludeFromCentring: true,
                },
            ];
        });
        const mapKey = computed(() => {
            const categoriesCount = Object.values(props.objectCategories).reduce((total, arr) => total + arr.length, 0);
            return `map-${props.offerId}-${categoriesCount}-${mapRefreshKey.value}`;
        });
        const highlightObject = (type, id) => {
            if (type === 'object')
                ctx.emit('highlight-object', id);
        };
        return {
            dataSets,
            highlightObject,
            mapKey,
        };
    },
});
